import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const getChannel = () => api.get("/channel").then((r) => r.data);
export const getCategories = () => api.get("/categories").then((r) => r.data);
export const listVideos = (params) => api.get("/videos", { params }).then((r) => r.data);
export const getVideo = (id) => api.get(`/videos/${id}`).then((r) => r.data);
export const getRelated = (id) => api.get(`/videos/${id}/related`).then((r) => r.data);

export const formatViews = (n) => {
  if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(1)} mi`;
  if (n >= 1_000) return `${(n / 1_000).toFixed(1)} mil`;
  return `${n}`;
};

export const timeAgo = (iso) => {
  const then = new Date(iso).getTime();
  const now = Date.now();
  const sec = Math.max(1, Math.floor((now - then) / 1000));
  const map = [
    [60 * 60 * 24 * 365, "ano"],
    [60 * 60 * 24 * 30, "mês"],
    [60 * 60 * 24 * 7, "sem"],
    [60 * 60 * 24, "dia"],
    [60 * 60, "h"],
    [60, "min"],
  ];
  for (const [s, label] of map) {
    if (sec >= s) {
      const v = Math.floor(sec / s);
      const plural = v > 1 && (label === "ano" || label === "dia" || label === "sem" || label === "min" || label === "h") ? "s" : "";
      return `há ${v} ${label}${plural}`;
    }
  }
  return "agora";
};
